parcelRequire.extendImportMap({"aykjc":"pow_bg.e56bb07e.wasm","lyHvT":"pow.worker.8c3779b0.js"});